export const initializeFlixMediaData = (labelName, id, unitPrice, soldBy) => {
    const headID = document.getElementsByTagName("head")[0];
    const flixScript = document.createElement('script');
    flixScript.type = 'text/tc_privacy';
    flixScript.async = true;
    flixScript.setAttribute('data-category', '3');
    flixScript.setAttribute('data-flix-distributor', '523');
    flixScript.setAttribute('data-flix-language', 'fr');
    flixScript.setAttribute('data-flix-brand', labelName);
    flixScript.setAttribute('data-flix-ean', id);
    flixScript.setAttribute('data-flix-mpn', '');
    flixScript.setAttribute('data-flix-inpage', 'flix-inpage');
    flixScript.setAttribute('data-flix-price', unitPrice);
    headID.appendChild(flixScript);
    flixScript.src = '//media.flixfacts.com/js/loader.js';
    const flixMarquedisableAttr = (soldBy !== 'MKP') ? 'disable' : ''
    $("#flix-inpage").wrap(
        `<div class="panel-fiche__collapse ${flixMarquedisableAttr}" id="flix-marque">` +
        '<div class="collapse" id="marque" style="">' +
        '<div class="panel-fiche__collapse__desc">' +
        '</div>' +
        '</div>' +
        '</div>')
    $('#flix-marque').prepend('<a href="#" class="panel-fiche__collapse__title collapsed" aria-expanded="false"><h3 class="panel-fiche__collapse__title__left partners-block-title" id="title"></h3><img id="image-arrow" class="image-arrow" src="/assets/images/responsive/icons/arrow.svg" alt="bouton flèche"></a>')
    $('#flix-marque').append('<span class="panel-fiche__collapse__border"></span>')
    document.getElementById("title").textContent = soldBy === 'MKP' ? 'Descriptif produit' : 'La marque vous informe';
    $('.panel-fiche__collapse__title').on('click', function (event) {
        event.preventDefault();
        const marque = $('#marque');
        if (marque.hasClass('collapse')) {
            marque.removeClass('collapse');
        } else {
            marque.addClass('collapse');
        }
        $('#image-arrow').toggleClass('rotated');
    });
    const flixContainer = document.getElementById('flix-inpage');
    if (flixContainer) {
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const flixContent = document.getElementById('flixinpage_');
                    if (flixContent) {
                        if (soldBy === 'MKP') {
                            $('#description-layer').addClass("hide-content");
                        } else {
                            $("#flix-marque").removeClass('disable');
                            $("#description").removeClass("hide-content");
                        }
                    } else if (soldBy === 'MKP') {
                        $("#flix-marque").removeClass('disable');
                        $("#description").removeClass("hide-content");
                    }
                }
            }
        });
        observer.observe(flixContainer, { childList: true, subtree: false });
    }
}

export const handleClickOnContent = () => {
    const marque = $('#marque');
    if (marque.hasClass('collapse')) {
        marque.removeClass('collapse');
    }
    $('#image-arrow').toggleClass('rotated');
}
